import BaseApi from "./baseAPI";
import { saveAs } from 'file-saver';

class FileAPI extends BaseApi{
  get entity() {
    return {
      route: `/file`,
      name: 'ملف'
    }
  }

  upload(data, config){
    return new Promise((resolve, reject) => {
      return this.request.post(`${this.entity.route}/upload`, data, config)
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  download(path, name = null){
    return new Promise((resolve, reject) => {
      return this.request.post(`${this.entity.route}`, {path: path}, {responseType: 'blob'})
        .then(response => {
          saveAs(new Blob([response.data]), name ? name : path)
          resolve(this.responseWrapper(response))
        })
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  import(data){
    return new Promise((resolve, reject) => {
        return this.request.post(`${this.entity.route}/import`, data)
          .then(response => resolve(this.responseWrapper(response)))
          .catch(error => reject(this.errorWrapper(error)))
    })
  }

}

export default new FileAPI()
